import axios from "axios";
import router from "@/router";

const redirectInterceptor = axios.create({});

redirectInterceptor.interceptors.request.use(function (config) {
  const token = localStorage.getItem("theyr_access_token");

  if (token && config.url && config.url.includes("nav.theyr.com")) {
    config.headers["Authorization"] = "Bearer " + token;
  }

  return config;
});

redirectInterceptor.interceptors.response.use(
  function (response) {
    return response;
  },

  function (error) {
    if (!error.response || !error.config) {
      return Promise.reject(error);
    }

    const status = error.response.status;
    const url = error.config.url || "";

    // THEYR API expired → drop the dead token, reload once
    if (status === 401 && url.includes("nav.theyr.com")) {
      const alreadyRetried = sessionStorage.getItem("theyr_reload_guard");

      localStorage.removeItem("theyr_access_token");

      if (!alreadyRetried) {
        sessionStorage.setItem("theyr_reload_guard", "1");
        window.location.reload();
      }

      return Promise.reject(error);
    }

    // normal backend auth
    if (status === 401 || status === 403) {
      if (router.currentRoute.name !== "login") {
        router.push({ name: "login" }).catch(() => {});
      }
    }

    return Promise.reject(error);
  }
);

export default redirectInterceptor;
